import React from "react";
import { AuthenticationStatus, InitiateAuth } from "../../service/Authentication";
import { FetchData, Status } from "../../service/BankData";
import { StatusMessage } from "../Status/StatusMessage";
import { AccountBalance } from "../AccountBalance/AccountBalance";
import { Spaces } from "../Spaces/Spaces";
import { DirectDebits } from "../DirectDebits/DirectDebits";
import { Header } from "../Header/Header";
import { StandingOrders } from "../StandingOrders/StandingOrders";
import { Transactions } from "../Transactions/Transactions";
import { UserTracker } from "../UserTracker/UserTracker";
import { AuthenticationForm } from "./AuthenticationForm";
import "./App.css";

const App: React.FC = () => {
  const { authenticate, authenticationStatus, token } = InitiateAuth();
  const { data, status } = FetchData(token);

  if (authenticationStatus === AuthenticationStatus.RequiresAuthentication) {
    return <AuthenticationForm authenticate={authenticate} />;
  }

  if (authenticationStatus === AuthenticationStatus.Unknown) {
    return <StatusMessage message="Authenticating..." />;
  }

  if (authenticationStatus === AuthenticationStatus.Unauthenticated) {
    return <StatusMessage message="Failed authentication" />;
  }

  if (status === Status.Loading) {
    return <StatusMessage message="Fetching data..." />;
  }

  if (status === Status.Error) {
    return <StatusMessage message="Error retrieving data" />;
  }

  return (
    <>
      <Header />
      <div className="App">
        <AccountBalance amount={data!.balance.amount} />
        <Spaces savingsGoals={data!.spaces} />
        <UserTracker transactions={data!.transactions} />
        <Transactions transactions={data!.transactions} />
        <StandingOrders standingOrders={data!.standingOrders} />
        <DirectDebits directDebits={data!.directDebits} />
      </div>
    </>
  );
};

export default App;
